import * as Yup from "yup";

export const narcoticsValidationSchema = Yup.object().shape({
  facility: Yup.string().required("Selected facility is required"),
  unit: Yup.string().required("Selected unit is required"),
  facilityDesignateName: Yup.string().required(
    "Facility designate name is required"
  ),
  pharmacyDesignateName: Yup.string().required(
    "Pharmacy designate name is required"
  ),
  completedBy: Yup.string().required("Completed by field is required"),

  // qualitative questions and section
  qualitative: Yup.object().shape({
    q1: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q2: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q3: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q4: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q5: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q6: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q7: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q8: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q9: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q10: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q11: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q12: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q13: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q14: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    q15: Yup.object().shape({
      answer: Yup.string()
        .oneOf(["met", "unmet"], "Answer must be 'met' or 'unmet'")
        .required("Response value is required"),
      comment: Yup.string(),
    }),
    compliance: Yup.object().shape({
      percentage: Yup.number()
        .min(0, "Percentage cannot be negative")
        .max(100, "Percentage cannot be greater than 100")
        .required("Compliance percentage is required"),
      outcome: Yup.boolean().required("Compliance outcome is required"),
    }),
  }),

  // quantitative questions and section
  quantitative: Yup.object().shape({
    quantitativeCompliance: Yup.object().shape({
      totalRecords: Yup.number()
        .min(0, "Total records cannot be negative")
        .required("Total records is required"),
      passedRecords: Yup.number()
        .min(0, "Passed records cannot be negative")
        .required("Passed records is required"),
    }),
    records: Yup.array()
      .of(
        Yup.object().shape({
          residentName: Yup.string().required("Resident name is required"),
          unit: Yup.string().required("Unit is required"),
          prescriptionNo: Yup.number().required(
            "Prescription number is required"
          ),
          medication: Yup.string().required("Medication is required"),
          quantity1: Yup.number()
            .min(0, "Only positive numbers allowed")
            .required("Quantity 1 is required"),
          quantity2: Yup.number()
            .min(0, "Only positive numbers allowed")
            .required("Quantity 2 is required"),
          quantity3: Yup.number()
            .min(0, "Only positive numbers allowed")
            .required("Quantity 3 is required"),
          outcome: Yup.boolean().required("Compliance outcome is required"),
        })
      )
      .min(1, "At least one patient record must be provided"),
  }),
});
